
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/review/write-review/[...params]",
      function () {
        return require("private-next-pages/review/write-review/[...params].tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/review/write-review/[...params]"])
      });
    }
  